//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import _ from "js/underscore-mixins";

(function() {
  const curalate = angular.module('curalate');

    /**
     * This component allows a user to fire callbacks based on a user inputting
     * a defined hotkey combination.
     * -
     * Once all keys in keyMap are depressed, downCallback() will fire.
     * -
     * Only after the keyMap combination is satisfied and all keys are
     * released, will upCallback() be fired.
     */
  curalate.component('hotkeys', {
    bindings: {
      keyMap: '=', // Array of integer keycodes
      downCallback: '&', // Function to call when combination is depressed
      upCallback: '&', // Function to call when combination is released
    },
    controllerAs: '$hotkeyCtrl',
    controller: [
      '$document',
      function(
                $document,
            ) {
        const self = this;
        let pressedKeys = [];
        let wasMatchedCombo;

        const isCombinationMissingKeys = function() {
          const missingKeys = _(self.keyMap).difference(pressedKeys);
          return !!missingKeys.length;
        };

        this.onKeyDown = function(keyCode) {
          pressedKeys.push(keyCode);
                    // No need to track duplicate key presses.
                    // For example, both shift keys are keyCode 16.
          pressedKeys = _(pressedKeys).uniq(true);
          const isMissingKeys = isCombinationMissingKeys();

          if (!isMissingKeys) {
            wasMatchedCombo = true;
            self.downCallback();
          }
        };

        this.onKeyUp = function(keyCode) {
          pressedKeys = _(pressedKeys).without(keyCode);

          const unreleasedKeys = _(pressedKeys).intersection(self.keyMap);

          if (wasMatchedCombo && unreleasedKeys.length === 0) {
            wasMatchedCombo = false;
            self.upCallback();
          }
        };

        const initOnKeyDown = function(event) {
          self.onKeyDown(event.keyCode);
        };

        const initOnKeyUp = function(event) {
          self.onKeyUp(event.keyCode);
        };

        this.$onInit = function() {
          $document.on('keydown', initOnKeyDown);
          $document.on('keyup', initOnKeyUp);
        };

        this.$onDestroy = function() {
          $document.off('keydown', initOnKeyDown);
          $document.off('keyup', initOnKeyUp);
        };
      },
    ],
  });
})();
